// extracted by mini-css-extract-plugin
module.exports = {"root":"LoginRightSection_root__JAemo","onboardingImage":"LoginRightSection_onboardingImage__hPJzI","onboardingAIBadge":"LoginRightSection_onboardingAIBadge__JDbzl"};